import { Component, HostBinding, Input } from "@angular/core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@Component({
  selector: "app-page-spinner",
  templateUrl: "./page-spinner.component.html",
  standalone: true,
  imports: [FontAwesomeModule],
  styleUrls: ["./page-spinner.component.scss"],
})
export class PageSpinnerComponent {
  faSpinner = faSpinner;

  @Input() withPadding = false;
  @Input() color = "";
  @Input() scale = 1;

  @HostBinding("class.with-padding") get isWithPadding(): boolean {
    return this.withPadding;
  }
  @HostBinding("style.transform") get getScale(): string {
    return `scale(${this.scale})`;
  }
  @HostBinding("style.color") get getColor(): string {
    return this.color || "var(--font-basic-color)";
  }
}
